import httpRequest from '@/request/index';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast } from 'vant';
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let userInfo = computed(() => {
      return store.state.userInfo;
    });
    let userBalance = computed(() => {
      return store.state.userBalance;
    });
    function login_out() {
      httpRequest({
        method: "post",
        url: "?file=out"
      }).then(res => {
        if (res.state == 1) {
          store.commit("logout");
          showToast({
            message: "退出成功",
            onClose: function () {
              router.replace("/login");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    }
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    return {
      login_out,
      userInfo,
      userBalance
    };
  }
};